import axios from 'axios';

export default {
  methods: {
    // TYLKO PODCZAS LOGOWANIA
    getTutorialStatus() {
      axios.get(process.env.VUE_APP_LARAVEL_ENDPOINT + "/api/user/tutorial")
        .then((response) => {
          sessionStorage.setItem('dashboardTutorial', response.data.tutorial.dashboard.toString());
          sessionStorage.setItem('pointsTutorial', response.data.tutorial.points.toString());
          // sessionStorage.setItem('personalTutorial', response.data.tutorial.personal.toString());
          // sessionStorage.setItem('historyTutorial', response.data.tutorial.history.toString());

          this.$router.push('/dashboard');
        })
        .catch((error) => {
          if (error.response) {
this.errors.push(error.response.data.message);}
else {
this.errors.push(error)}
        })
    },
    setTutorialStatus(pageName) {
      axios.post(process.env.VUE_APP_LARAVEL_ENDPOINT + '/api/user/tutorial/' + pageName)
        .catch((error) => {
          if (error.response) {
this.errors.push(error.response.data.message);}
else {
this.errors.push(error)}
        })
    }
  }
}
